export default "__VITE_ASSET__BWNuuqve__"